const SIZE = 4;

export const initBoard = () =>
  Array.from({ length: SIZE }, () => Array(SIZE).fill(0));

const cloneBoard = (board) => board.map((row) => [...row]);

const slideAndMerge = (row) => {
  let arr = row.filter((v) => v !== 0);
  let score = 0;

  for (let i = 0; i < arr.length - 1; i++) {
    if (arr[i] === arr[i + 1]) {
      arr[i] *= 2;
      score += arr[i];
      arr[i + 1] = 0;
      i++; // prevent double merge
    }
  }

  arr = arr.filter((v) => v !== 0);
  while (arr.length < SIZE) arr.push(0);

  return { newRow: arr, score };
};

const rotateRight = (board) =>
  board[0].map((_, i) => board.map((row) => row[i]).reverse());

const rotateLeft = (board) =>
  board[0].map((_, i) => board.map((row) => row[row.length - 1 - i]));

const boardsEqual = (a, b) =>
  a.every((row, i) => row.every((v, j) => v === b[i][j]));

export const moveBoard = (board, direction) => {
  let rotated = cloneBoard(board);
  let totalScore = 0;

  if (direction === "UP") rotated = rotateLeft(rotated);
  if (direction === "DOWN") rotated = rotateRight(rotated);
  if (direction === "RIGHT") rotated = rotated.map((r) => r.reverse());

  rotated = rotated.map((row) => {
    const result = slideAndMerge(row);
    totalScore += result.score;
    return result.newRow;
  });

  if (direction === "UP") rotated = rotateRight(rotated);
  if (direction === "DOWN") rotated = rotateLeft(rotated);
  if (direction === "RIGHT") rotated = rotated.map((r) => r.reverse());

  return {
    board: rotated,
    moved: !boardsEqual(board, rotated),
    score: totalScore,
  };
};

export const addRandomTile = (board) => {
  const empty = [];
  board.forEach((row, r) =>
    row.forEach((v, c) => {
      if (v === 0) empty.push([r, c]);
    })
  );

  if (empty.length === 0) return board;

  const [r, c] = empty[Math.floor(Math.random() * empty.length)];
  const newBoard = cloneBoard(board);
  newBoard[r][c] = Math.random() < 0.9 ? 2 : 4;

  return newBoard;
};

export const isGameOver = (board) => {
  for (let r = 0; r < SIZE; r++) {
    for (let c = 0; c < SIZE; c++) {
      if (board[r][c] === 0) return false;
      if (c < SIZE - 1 && board[r][c] === board[r][c + 1]) return false;
      if (r < SIZE - 1 && board[r][c] === board[r + 1][c]) return false;
    }
  }
  return true;
};
